import _JSON$stringify from "@babel/runtime-corejs3/core-js-stable/json/stringify";
export var loadSessionStorageState = function loadSessionStorageState() {
  try {
    var serializableState = sessionStorage.getItem('alerts_state');

    if (serializableState !== null) {
      return JSON.parse(serializableState);
    }

    return undefined;
  } catch (err) {
    return undefined;
  }
};
export var saveSessionStorageState = function saveSessionStorageState(state) {
  try {
    var serializableState = _JSON$stringify(state);

    sessionStorage.setItem('alerts_state', serializableState);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('An error occurred while saving alerts_state. Error details: ', err);
  }
};
export var removeSessionStorageState = function removeSessionStorageState() {
  try {
    sessionStorage.removeItem('alerts_state');
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('An error occurred while removing alerts_state. Error details: ', err);
  }
};